// #466: o contador de não-lidas do Chat Interno aparece UMA vez, no nível mais
// fundo da sidebar que o usuário consegue ver. O item mora em Chat › Operação;
// com o módulo ou o grupo fechados (o padrão fora do Chat), o badge do item
// ficava escondido e a mensagem passava despercebida.
export type UnreadAnchor = "module" | "group" | "item";

export interface UnreadAnchorInput {
  total: number;
  /** O item passa no filtro de permissão/módulo — sem ele, não há o que apontar. */
  itemVisible: boolean;
  sidebarCollapsed: boolean;
  moduleExpanded: boolean;
  groupExpanded: boolean;
}

export function unreadAnchor({
  total,
  itemVisible,
  sidebarCollapsed,
  moduleExpanded,
  groupExpanded,
}: UnreadAnchorInput): UnreadAnchor | null {
  if (total <= 0 || !itemVisible) return null;
  // Recolhida, a sidebar só mostra o ícone do módulo — a expansão não vale.
  if (sidebarCollapsed || !moduleExpanded) return "module";
  if (!groupExpanded) return "group";
  return "item";
}
